<template>
    <modal name="registro" :scrollable="true" :height="'auto'" :clickToClose="false">
    <div class="container p-5 modal-content-rounded">
        <div class="text-center mb-4">
            <h3 class="with-lines">Registro</h3>
        </div>
        <div class="row p-1 mr-1">
            <label class="col-sm-2 col-form-label">Tipo</label>
            <select disabled class="form-select form-select-sm col-sm-10 diferentInput" >
                <option selected>Proveedor</option>
            </select>
        </div>
        <div class="p-1">
            <div class="row">
                <label class="col-sm-2 col-form-label">RFC</label>
                <div class="input-group input-group-sm mb-3 col-sm-10">
                    <input type="text" class="form-control diferentInput" v-model="rfc" @input="validateRFC($event) ">
                    <span class="invalidEmail col-12" v-if="!valiRFC">Por favor, introduce un RFC que sea válido. </span>
                </div>
                
            </div>
            <div class="row">
                <label class="col-sm-4 col-form-label">Nombre Comercial</label>
                <div class="input-group input-group-sm mb-3 col-sm-8">
                    <input type="text" class="form-control diferentInput" v-model="nombreComercial">
                </div>
            </div>
            <div class="row">
                <label class="col-sm-2 col-form-label">Email</label>
                <div class="input-group input-group-sm mb-3 col-sm-10">
                    <input type="email" class="form-control diferentInput" v-model="email" @input="validateEmail($event)">
                    <span class="invalidEmail col-12" v-if="!validEmail">Por favor, introduce un correo electrónico válido.</span>
                </div>
            </div>
            
        </div>
        <div class="row mt-4">
                <div class="col-md-5"></div>
                <div class="col-md-4 float-right">
                    <button class="btn btn-danger float-right" style="border-radius: 15px;" @click="closeModal" ><i class="fas fa-times-circle mr-2"></i>Cerrar</button>
                </div>
                <div class="col-md-3 float-right ">
                    <button class="btn btn-primary float-righ"  @click="enviarFormulario"> <i class="fas fa-check-circle mr-2"></i>Registrar</button>
                </div>

            </div>


    </div>
    </modal>
</template>

<script scoped>
import VueRecaptcha from "../../../../node_modules/vue-recaptcha";

export default {
    components: {
        VueRecaptcha,
    },
    props: {
        cleanModal: Boolean
    },
    data() {
        return { 
            rfc: '',
            email: '',
            nombreComercial: '',
        
            validEmail: true,
            valiRFC: true
        }
    },
    watch: {
        cleanModal(value) {
            if (value) {
                this.limpiarControles();
            }
        },
    },
    methods:{
        enviarFormulario(){
            let datosFormularios = {
                'RFC': this.rfc,
                'Nombre': this.nombreComercial,
                'Email': this.email
                
            }

            this.$emit('formularioCompletado', datosFormularios);
        },
        validateRFC(event){
            this.rfc = event.target.value.replace(/[^a-zA-Z0-9ñÑ]/g, '');
        },
        validateEmail(event) {
            const email = event.target.value;
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            this.validEmail = emailPattern.test(email);
            this.email = email;
        }, 
        closeModal(){
            this.$modal.hide('registro')
            this.rfc = ''
            this.nombreComercial = ''
            this.email = ''
            this.valiRFC = true
            this.validEmail = true
        },
        limpiarControles() {
            console.log('limpiarControles');
            this.rfc = '';
            this.nombreComercial = '';
            this.email = '';
            this.valiRFC = true
            this.validEmail = true
        },
    },
    mounted() {
    },
}
</script>
<style>
.modal-content-rounded {
  border-radius: 15px; /* Ajusta el valor según tus necesidades */
}
.diferentInput{
  border: none;
  border-bottom: 2px solid rgba(128, 128, 128, 0.568);
}
h3{
    color: #003c717a;
}
.with-lines {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.with-lines::before,
.with-lines::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid #003c717a;
    margin: 0 10px;
}
.invalidEmail{
    font-size: small;
    color: red;
}
.file-select {
    position: relative;
    display: inline-block;
    width: 330px;
    height: 30px;
    margin-right: 20px;
    cursor: pointer;
    /* Añade un borde alrededor del elemento */
    border: 1px solid #cccccca6;
    border-radius: 5px;

}

.file-select::before {
    background-color: #ffffff;
    color: rgba(153, 152, 152, 0.548);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    font-size: small;
    content: "Seleccionar archivo";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
}
.col-md-6, .col-md-5, .col-md-3, .col-md-4 {
    padding-right: 7px !important;
    padding-left: 7px !important;
}
.btn-primary{
    background-image: linear-gradient(to right, #085da8, #003c71);
    border-radius: 15px !important;
}
.btn-secondary{
    background-color: #276E90 !important;
    border-color: #276E90 !important;
    color: white;
}
.vm--modal {
  border-radius: 30px !important;
  }
  .vue-js-modal .v--modal-box {
  border-radius: 15px; /* Ajusta el valor según tus necesidades */
  overflow: hidden; /* Para que el contenido no sobresalga de las esquinas redondeadas */
}
</style>